import isEqual from 'lodash/isEqual';

import { BillToDetails } from '@rygen/rygen-ui/model';

import { EmbeddableLocation } from '../EmbeddableLocation';

export class ShipmentBillTo {
  id?: number;
  location: EmbeddableLocation = new EmbeddableLocation();
  billToDetails: BillToDetails = new BillToDetails();

  readonly isShipmentBillTo: true = true;
  static emptyBillTo = new ShipmentBillTo();

  constructor(opts?: Partial<ShipmentBillTo>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.location != null) {
      this.location = new EmbeddableLocation(opts.location);
    }

    if (opts?.billToDetails != null) {
      this.billToDetails = new BillToDetails(opts.billToDetails);
    }
  }

  static isShipmentBillTo(billTo: unknown): billTo is ShipmentBillTo {
    return !!billTo && (billTo as ShipmentBillTo).isShipmentBillTo === true;
  }

  get isEmpty() {
    return isEqual(this, ShipmentBillTo.emptyBillTo);
  }
}
